// Global web error reporting (funnel audit R18) — the web funnel's black
// box. iOS has Crashlytics; until now an uncaught JS error on the invite
// landing or the save modal vanished without a trace. These handlers forward
// uncaught errors + unhandled rejections to the logClientError callable
// (→ admin-only `_clientErrors` collection).
//
// Deliberately tiny, no SDK: self-caps per session, dedupes repeats, and
// every failure path swallows — an error reporter must never throw.

import { functions } from '../firebase.js';

const MAX_PER_SESSION = 5;
let sent = 0;
const seen = new Set();

function report(context, message, stack) {
  try {
    if (!message || sent >= MAX_PER_SESSION) return;
    const key = String(message).slice(0, 120);
    if (seen.has(key)) return;
    seen.add(key);
    sent += 1;
    functions
      .httpsCallable('logClientError')({
        message: String(message).slice(0, 500),
        stack: String(stack || '').slice(0, 4000),
        url: window.location.pathname + window.location.search,
        userAgent: navigator.userAgent,
        context,
      })
      .catch(() => {});
  } catch {
    /* never let the reporter itself surface */
  }
}

export function installErrorReporting() {
  window.addEventListener('error', (e) => {
    // Resource-load errors (img/script tags) fire here with no error object
    // and near-zero signal — skip them, keep the JS errors.
    if (!e || (!e.error && !e.message)) return;
    report('onerror', e.message || String(e.error), e.error && e.error.stack);
  });
  window.addEventListener('unhandledrejection', (e) => {
    const r = e && e.reason;
    if (!r) return;
    report('unhandledrejection', r.message || String(r), r.stack);
  });
}
